export function MraProgressBar(){
    $('.scheduler-modal .modal-content').removeClass('banner-wizard');
    // $('.progressbar li').css('width', 'calc(100%/3)');
    $('.schedule-list').removeClass('schedule-list');
    // $('.scheduler-slide .progress').css("max-width","310px");
    // $('.scheduler-slide .progressbar').css("max-width","440px");
    $('.progress, .progressbar').show();
}